import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GenericResponse } from '../models/generic-response';
import { GetModulesPayload, GetModulesRequest, GetModulesResponse } from '../models/modules.model';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VisualizarModulesService {
  readonly #http = inject(HttpClient);

  get url(): string {
    return environment.login;
  }


  getModules(value: GetModulesRequest) {
    const adaptedRequest = this.#adaptGetModulesRequestToPayload(value);

    return this.#http.post<GenericResponse<GetModulesResponse, null>>(`${this.url}/administradorOfertas`, adaptedRequest)
    .pipe(
      map(({ responseObject }) => ({
        ...responseObject,
        modulosActivos: responseObject.modulosActivos.map((m) => ({
          ...m,
          label: m.label.replace('VENTAS DAT', 'VENTAS').trim()
        }))
      }))
    );
  }


  #adaptGetModulesRequestToPayload(request: GetModulesRequest): GetModulesPayload {
    return {
      token: request.token,
      payload: {
        ruta: request.route,
        idAgente: request.agentID
      }
    }
  }
}
